import { Box, Button, Checkbox, Container, FormControlLabel, Typography, styled } from '@mui/material'
import { BackButton } from '../components/BackButton'
import { useContext, useState } from 'react'
import { HotelContext } from '../contexts/HotelContext'
import { useNavigate } from 'react-router'

export const StyledIdentityCardGuide = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;

  .page-content {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .term-label {
    color: #0237ac;
  }
`

export const IdentityCardGuide = () => {
  const { hotel } = useContext(HotelContext)
  const navigate = useNavigate()
  const [checked, setChecked] = useState(true)

  const onSubmit = () => {
    navigate(`/hotel/${hotel.hotelId}/identity`)
  }

  return (
    <StyledIdentityCardGuide maxWidth="md">
      <BackButton to={`/hotel/${hotel.hotelId}/checkin`} />
      <Box>
        <Typography
          color={(theme) => theme.palette.primary.main}
          mt={1}
          textAlign="center"
          variant="h4"
          gutterBottom
          fontWeight="600">
          Thủ tục nhận phòng
        </Typography>
      </Box>
      <Box className="page-content">
        <Box padding={4}>
          <Typography fontSize="1.5rem">
            <span>
              Xin vui lòng chụp ảnh <b>2 CCCD (HAI CCCD)</b> để hoàn tất thủ tục.
            </span>
            <br />
            <span>- Khách sạn sẽ sử dụng thông tin để khai báo lưu trú theo quy định nhà nước.</span>
            <br />
            <span>- Cam kết chúng tôi không sử dụng thông tin với mục đích khác.</span>
          </Typography>
        </Box>
        <Box>
          <FormControlLabel
            sx={() => ({
              '.MuiSvgIcon-root': { fontSize: '2.5rem' },
            })}
            control={<Checkbox checked={checked} onChange={() => setChecked(!checked)} />}
            label={
              <Typography fontSize="1rem">
                <b className="term-label">Tôi đồng ý với điều kiện và điều khoản trên</b>
                <br />
                Tôi xin cam kết các thông tin tôi cung cấp là đúng sự thật và sẽ chịu trách nhiệm với pháp luật về những
                thông tin này
              </Typography>
            }
          />
        </Box>
      </Box>
      <Box width="100%" paddingTop={4}>
        <Button disabled={!checked} size="large" fullWidth variant="contained" type="submit" onClick={onSubmit}>
          Tiếp tục
        </Button>
      </Box>
    </StyledIdentityCardGuide>
  )
}
